import type { BatMetadataConfigEntry } from './common/types';
import { coreFields, genericUnitField } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productCategoryField, productFields } from './common/productFields';
import { msg } from '@lingui/core/macro';

export const soldRetailGoodMetadata = {
  displayName: msg({
    message: 'Sold products: Retail',
    context: 'Activity data schema name for sold retail goods',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    is_energy_star: {
      displayName: msg({
        message: 'Energy Star certified',
        context:
          'Indicator of whether the good sold is an Energy Star product.',
      }),
      externalDescription: msg({
        message:
          'Indicator of whether the good sold is an Energy Star product.',
        context: 'Energy Star certified',
      }),
    },
    product_category: productCategoryField,
    quantity: {
      displayName: msg({
        message: 'Product quantity',
        context: 'The quantity of good sold.',
      }),
      externalDescription: msg({
        message: 'The quantity of good sold.',
        context: 'Product quantity',
      }),
    },
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
